export class ProjectHistoryActionDef {
  public static readonly UNDEFINED: number = -1;

  public static readonly CREATED_PROJECT: number = 0;
  public static readonly REQUESTED_PROJECT: number = 1;
  public static readonly EDITED_PROJECT: number = 2;
  public static readonly FINALIZED_PROJECT: number = 3;
  public static readonly FINALIZED_LEGACY_PROJECT: number = 4;
  public static readonly ORDERED_PROJECT: number = 5;
  public static readonly CREATED_NEW_PROJECT_VERSION: number = 6;
  public static readonly CHANGED_FINALIZATION_STATE: number = 7;
  public static readonly LOCKED_PROJECT: number = 8;
  public static readonly UNLOCKED_PROJECT: number = 9;
  public static readonly FINALIZED_PROJECT_WITHOUT_PDM: number = 10;

  public static readonly PROJECT_HISTORY_ACTION_TO_SORT_ORDER_MAP = new Map<ProjectHistoryActionDef, number>([
    [ProjectHistoryActionDef.ORDERED_PROJECT, 0],
    [ProjectHistoryActionDef.FINALIZED_PROJECT, 1],
    [ProjectHistoryActionDef.FINALIZED_LEGACY_PROJECT, 2],
    [ProjectHistoryActionDef.FINALIZED_PROJECT_WITHOUT_PDM, 3],
    [ProjectHistoryActionDef.CHANGED_FINALIZATION_STATE, 4],
    [ProjectHistoryActionDef.LOCKED_PROJECT, 5],
    [ProjectHistoryActionDef.UNLOCKED_PROJECT, 6],
    [ProjectHistoryActionDef.REQUESTED_PROJECT, 7],
    [ProjectHistoryActionDef.CREATED_NEW_PROJECT_VERSION, 8],
    [ProjectHistoryActionDef.EDITED_PROJECT, 9],
    [ProjectHistoryActionDef.CREATED_PROJECT, 10],
  ]);
}
